<tgrid-layer-header [layer]="this" [additionIcons]="iconConfig()">
<!--  <span class="info-message">Economic cost of outage shown are for {{ selectedYear() }}</span>-->
<!--  <span class="info-message sub">The data shown reflects the most recent year selected in the date filter above</span>-->

  <div ngProjectAs="filters">
    <form [formGroup]="filterGroup">
      <mat-form-field class="wide" appearance="outline">
        <mat-label>Sector</mat-label>
        <mat-select formControlName="sector">
          @for (sector of sectors.values(); track sector) {
            <mat-option [value]="sector">{{ getSectorDisplayName(sector) }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

    </form>


    <div class="legend">
      <div #legendBar class="legend-bar"></div>
      <div class="legend-container">
        <div class="legend-labels">
          <span>{{ legendBounds().min | compactCurrency }}</span>
          <small>normal distribution</small>
          <span>{{ legendBounds().max | compactCurrency }}</span>
        </div>
      </div>

      <div class="legend-extras">
        <div class="ntl-data">
          <div class="legend-box"></div>
          <span>NTL</span>
        </div>
      </div>

    </div>


  </div>


</tgrid-layer-header>
